<template>
  <div class="content">
    <div v-if="enableFavoritesModal">
      <div class="row">
        <p class="new-modal-description">{{ textMessage }}</p>
      </div>
      <div class="row">
        <img v-show="imageUrl" class="modals-favorites-img" :src="imageUrl" :alt="pdm.product_name" @load="hideSpinner(true)" />
      </div>
      <base-spinner v-show="showSpinner"></base-spinner>
    </div>
    <h5 class="text-center subheader" v-else>{{ textMessage }}</h5>
  </div>
</template>

<script>
import baseSpinner from '@/components/Spinner';

import favorites from '@/mixins/Favorites';

export default {
  name: 'FavoritesModal',
  mixins: [favorites],
  props: {
    contentProps: {
      default: Object,
      type: Object
    },
    paramsContentComponent: {
      default: Object,
      type: Object
    }
  },
  components: {
    baseSpinner
  },
  computed: {
    pdm() {
      return this.$store.state.utils.pdm;
    },
    isFavoriteSaved() {
      return this.contentProps.favoriteSaved || this.paramsContentComponent.favoriteSaved;
    },
    textMessage() {
      if (this.isFavoriteSaved) {
        return this.translations.favoritesSuccessMessage;
      } else {
        return this.translations.favoritesErrorMessage;
      }
    }
  },
  created() {
		this.getProductImage({ recipe_id: this.$store.state.recipe.recipeId });
	}
};
</script>
